import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import ListDivider from "@mui/joy/ListDivider";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useUserMeQuery } from "../../__generated__/types-and-hooks";
import { Link, useNavigate } from "react-router-dom";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "../../i18n";

export default function ProfileDropDown() {
  const navigate = useNavigate();
  const myProfile = useUserMeQuery();
  const t = useTranslation();
  const fullName = [myProfile?.data?.user_me.firstName, myProfile?.data?.user_me.lastName].filter(Boolean).join(" ") || t('User');

  return (
    <Dropdown>
      <MenuButton
        // variant="plain"
        size="sm"
        fullWidth
        sx={{
          p: 0,
          m: 0,
          maxHeight: "32px",
          // maxWidth: "32px",
          // maxHeight: "32px",
          borderRadius: "var(--joy-radius-sm)",
          justifyContent: "flex-start",
          overflow: "hidden",
        }}
        endDecorator={
          <Box sx={{ display: { xs: "flex", sm: "none", lg: "flex" } }}>
            <ArrowDropDown fontSize="medium" />
          </Box>
        }
      >
        <Avatar
          src={myProfile?.data?.user_me.picture ?? ""}
          sx={{
            borderRadius: "var(--joy-radius-sm)",
            // maxWidth: "30px",
            // maxHeight: "30px",
          }}
        />
        <Typography
          fontSize="small"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "no-wrap",
            overflow: "hidden",
            ml: 1,
            display: { xs: "flex", sm: "none", lg: "flex" },
          }}
        >
          {fullName}
        </Typography>
      </MenuButton>
      <Menu
        placement="bottom-end"
        size="sm"
        sx={{
          zIndex: "99999",
          p: 1,
          gap: 1,
          "--ListItem-radius": "var(--joy-radius-sm)",
        }}
      >
        <MenuItem
          onClick={() => navigate(`/user/${myProfile?.data?.user_me.slug}`)}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Avatar
              src={myProfile.data?.user_me.picture ?? ""}
              sx={{ borderRadius: "50%" }}
            />
            {myProfile.data && (
              <Box sx={{ ml: 1.5 }}>
                <Typography level="title-sm" textColor="text.primary">
                  {fullName}
                </Typography>
                <Typography level="body-xs" textColor="text.tertiary">
                  {myProfile.data.user_me.slug}
                </Typography>
              </Box>
            )}
          </Box>
        </MenuItem>
        <MenuItem component={Link} to={"/org"}>
          <GroupsOutlinedIcon />
          {t("Membership")}
        </MenuItem>
        <MenuItem component={Link} to={"/api-keys"}>
          <VpnKeyOutlinedIcon />
          {t("API Keys")}
        </MenuItem>
        <ListDivider />
        <MenuItem
          component={Link}
          target="_blank"
          to={process.env.REACT_APP_HELP_LINK as string}
        >
          <HelpRoundedIcon />
          {t("Help")}
          <OpenInNewRoundedIcon />
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.location.href = "/auth/sign-in";
          }}
        >
          <LogoutRoundedIcon />
          {t("Log out")}
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}
